<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chap-title" id="pagev">List of Maps</h2>
<p class="foot1">
</p><p class="map">1. The operations of 1191 and 1194</p>
<p class="map">2. The operations against the Tatars in 1196</p>
<p class="map">3. Various events from 1196 to 1199</p>
<p class="map">4. The attacks on the Naimans in 1199 (first part), 1206, and 1208</p>
<p class="map">5. The second part of the 1199 campaign</p>
<p class="map">6. The operations against Tayici’ut in 1200</p>
<p class="map">7. The operations in East Mongolia 1201 and 1202</p>
<p class="map">8. The Köyiten campaign in 1202–1203</p>
<p class="map">9. The confrontation with To’oril in 1203</p>
<p class="map">10. The defeat of the Naimans in 1204–1205</p>
<p class="map">11. The invasion of Xia in 1209–1210</p>
<p class="map">12. The first attack on the Jin in 1211–1212</p>
<p class="map">13. The continued operations against the Jin in 1212 and 1213–1214</p>
<p class="map">14. The first campaigns in the Western region 1216–1220</p>
<p class="map">15. The advance to the Sindhu River 1221</p>
<p class="map">16. Circling the Caspian Sea I, 1220–1222</p>
<p class="map">17. Circling the Caspian Sea II, 1222–1224</p>
<p class="map">18. The final confrontation with Xia 1226–1228</p>
<p class="map">19. The operations in central China 1230–1231</p>
<p class="map">20. The assault on Song Hanzhong 1231–1232</p>
<p class="map">21. The Sanfeng campaign 1232</p>
<p class="map">22. The final operations against Jin 1232–1234</p>
<p class="map">23. The Song attempt to recover Kaifeng and Luoyang in 1234</p>
<p class="map">24. The conquest of the Volga Bulgars, Rus, Kipchaks, and other tribes 1236–1240</p>
<p class="map">25. The invasion of Central Europe 1241</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_List_of_Maps.vue?dc1d10e6